import React, {
  useState,
  useRef,
  useMemo,
  Dispatch,
  SetStateAction,
} from "react";
import JoditEditor from "jodit-react";

type Props = {
  placeholder?: string;
  setValue: Dispatch<SetStateAction<string>>;
  value: string;
};
const BlogEditor: React.FC<Props> = ({ placeholder, value, setValue }) => {
  const editor = useRef(null);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: placeholder || "Start typings...",
    }),
    [placeholder]
  );
  const handleChange = (newContent: string) => {
    setValue(newContent);
  };
  return (
    <JoditEditor
      ref={editor}
      value={value}
      config={config}
      // tabIndex={1}
      // onBlur={(newContent) => setValue(newContent)}
      onChange={handleChange}
    />
  );
};

export default BlogEditor;
